<div  class="modal-dialog {{ modalSize || 'modal-md' }}">
  <div class="modal-header">
    <div class="closedRadius">
      <a class="button-close glyphicon glyphicon-remove-circle" (click)="cancel()"></a>
    </div>
    <br />
    <h4 class="modal-title">
      {{ title || 'Confirm' }} <span class="pull-right spinner" *ngIf="showSpinner || false"></span>
    </h4>
    <hr *ngIf="showHeaderDivider" />
  </div>
  <div class="modal-body">
    <span *ngIf="isMessageDisplayedInTextArea">
      <textarea class="modal-textarea">{{ message }}</textarea>
    </span>
    <span *ngIf="!isMessageDisplayedInTextArea">
      <div [innerHTML]="message"></div>
    </span>
    <p *ngIf="!message">{{ 'Are you sure?' }}</p>
  </div>
  <div *ngIf="isHiddenFooter" class="empty-footer"></div>
  <div *ngIf="!isWarning && (!isHiddenFooter || false)" class="modal-footer">
    <button *ngIf="!isHiddenConfirmButton" type="button" class="btn btn-primary" (click)="confirm()">
      Continue
    </button>
    <button *ngIf="!isHiddenCloseButton" type="button" class="btn btn-link" (click)="close()">
      Cancel
    </button>
  </div>
  <div *ngIf="isWarning && (!isHiddenFooter || false)" class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="close()">Close</button>
  </div>
</div>